export const booleanInputHandler = callback => (event, checked) => {
	const field = event.target.name;
	callback({ [field]: checked });
};

export const radioInputHandler = callback => (event, value) => {
	const field = event.target.name;
	callback({ [field]: value });
};

export const selectInputHandler = callback => ({ target = {} }) => {
	const { name: field, value } = target;
	callback({ [field]: value });
};
